// Resolves the backend API + WebSocket origins at build time.
//
// Web dev: leave VITE_API_BASE_URL unset → API_BASE_URL is '' (relative paths), and the
//   Vite dev server proxies /api and /ws to localhost:3001 (see vite.config.ts).
// Native/release: in a packaged Capacitor WebView the origin is https://localhost (Android)
//   or capacitor://localhost (iOS), so relative paths can never reach a remote server.
//   Bake in the hosted backend by setting VITE_API_BASE_URL (e.g. https://api.traintopia.com)
//   before `pnpm build` + `cap sync`.
const apiBase = (
  import.meta.env.VITE_API_BASE_URL ||
  (import.meta.env.DEV ? '' : 'https://api.whosbaron.com')
).replace(/\/$/, '')

/** Absolute origin to prefix every /api and /health request with ('' = same-origin). */
export const API_BASE_URL = apiBase

/** WebSocket endpoint for live vehicle/alert pushes. */
export const WS_URL = ((): string => {
  const explicit = import.meta.env.VITE_WS_URL
  if (explicit) return explicit
  if (apiBase) return `${apiBase.replace(/^http/, 'ws')}/ws`
  // Same-origin fallback for web dev (Vite proxy forwards to the backend).
  return `${window.location.protocol === 'https:' ? 'wss' : 'ws'}://${window.location.host}/ws`
})()
